export const PRINT_PREVIEW_KEY = 'ua-print-preview';
